export const formatDecimalHoursToHM = (decimalHours) => {
  if(!decimalHours) return '0м'
  const hours = Math.floor(decimalHours);

  const minutes = Math.round((decimalHours - hours) * 60);
  return !minutes
    ? `${hours.toLocaleString()}ч`
    : !hours
      ? `${minutes}м`
      : `${hours.toLocaleString()}ч ${minutes}м`
}